// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stopMap_root_CIYeP {
  position: relative;
}

.stopMap_mapContainer_Mdbsx {
  border-radius: var(--border-radius);
  overflow: hidden;
}

.stopMap_mapContainer_Mdbsx img {
  width: 100%;
}

.stopMap_map_L4u9N {
  width: 100%;
  height: 100%;
}

.stopMap_miniMap_oil_l {
  position: absolute;
  border: 10px solid var(--background);
}

.stopMap_legend_RV8sy {
  z-index: 20;
  background-color: white;
  border-radius: 15px;
  border: 5px solid var(--background);
  min-width: 200px;
  min-height: 30px;
}

.stopMap_legendRow_t3Yvb {
  padding: 5px;
  display: flex;
  align-items: center;
}

.stopMap_legendText_ELeev {
  color: black;
  margin-left: 10px;
  font-family: GothamRounded-Book;
  font-size: 0.9em;
  white-space: nowrap;
}

.stopMap_legendLine_Q8EkG {
  width: 40px;
}

.stopMap_legendLine_Q8EkG.stopMap_bus_USe5I {
  border: 2px solid rgb(0, 122, 201);
}

.stopMap_legendLine_Q8EkG.stopMap_tram_KimUA {
  border: 2px solid rgb(0, 152, 95);
}

.stopMap_legendLine_Q8EkG.stopMap_subway_XL4LV {
  border: 2px dashed rgb(255, 99, 25);
}

.stopMap_legendLine_Q8EkG.stopMap_rail_mXhj1 {
  border: 2px dashed rgb(141, 81, 153);
}

.stopMap_legendLine_Q8EkG.stopMap_trunk_wW15F {
  border: 2px solid rgb(255, 99, 25);
}

.stopMap_legendLine_Q8EkG.stopMap_l_rail_gnsYu {
  border: 2px solid #0098a1;
}

.stopMap_legendIcon_nIVeI {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: white;
  position: absolute;
  left: 20px;
}

.stopMap_legendIcon_nIVeI.stopMap_bus_USe5I {
  border: 2px solid rgb(0, 122, 201);
}

.stopMap_legendIcon_nIVeI.stopMap_tram_KimUA {
  border: 2px solid rgb(0, 152, 95);
}

.stopMap_legendIcon_nIVeI.stopMap_subway_XL4LV {
  border: 2px solid rgb(255, 99, 25);
}

.stopMap_legendIcon_nIVeI.stopMap_rail_mXhj1 {
  border: 2px solid rgb(141, 81, 153);
}

.stopMap_legendIcon_nIVeI.stopMap_trunk_wW15F {
  border: 2px solid rgb(255, 99, 25);
}

.stopMap_legendIcon_nIVeI.stopMap_l_rail_gnsYu {
  border: 2px solid #0098a1;
}

.stopMap_primaryLegendText_dx6CE {
  font-family: GothamRounded-Medium;
}

.stopMap_italics_X3nTh {
  font-style: italic;
}

.stopMap_overlays_g64MF {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: var(--border-radius);
}

.stopMap_outline_H0yuX {
  text-shadow: 0px 0px 1px rgba(255, 255, 255, 1), 0px 0px 1px rgba(255, 255, 255, 1),
    0px 0px 1px rgba(255, 255, 255, 1);
}

.stopMap_attribution_Im4HY {
  margin: 8px 0;
  font-family: GothamRounded-Medium;
  color: black;
}

.stopMap_title_nFuhW {
  margin-top: 3px;
  margin-bottom: 3px;
  margin-left: 3px;
  margin-right: 8px;
  font-size: 18px;
  font-family: GothamRounded-Medium;
  color: black;
}

.stopMap_subtitle_sJDDg {
  margin-left: 0;
  font-family: GothamRounded-Book;
}

.stopMap_center_jW3e2 {
  position: absolute;
  top: 50%;
  left: 50%;
}

.stopMap_zoneHeading_UvJcf {
  font-family: GothamRounded-Book;
  font-size: 20px;
  vertical-align: middle;
  line-height: 1.1rem;
  display: flex;
  align-items: center;
  width: 100%;
  color: rgb(0, 122, 201);
  white-space: nowrap;
  flex-wrap: nowrap;
}

.stopMap_zoneSymbol_Tyisz {
  height: 60px;
  width: 60px;
  vertical-align: middle;
  display: flex;
  align-items: center;
  padding-left: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/map/stopMap.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EAEE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EAEE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE;sCACoC;AACtC;;AAEA;EAEE,aAAa;EACb,iCAAiC;EACjC,YAAY;AACd;;AAEA;EAEE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,YAAY;AACd;;AAEA;EAEE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":[".root {\n  position: relative;\n}\n\n.mapContainer {\n  border-radius: var(--border-radius);\n  overflow: hidden;\n}\n\n.mapContainer img {\n  width: 100%;\n}\n\n.map {\n  composes: mapContainer;\n  width: 100%;\n  height: 100%;\n}\n\n.miniMap {\n  composes: mapContainer;\n  position: absolute;\n  border: 10px solid var(--background);\n}\n\n.legend {\n  composes: mapContainer;\n  z-index: 20;\n  background-color: white;\n  border-radius: 15px;\n  border: 5px solid var(--background);\n  min-width: 200px;\n  min-height: 30px;\n}\n\n.legendRow {\n  padding: 5px;\n  display: flex;\n  align-items: center;\n}\n\n.legendText {\n  color: black;\n  margin-left: 10px;\n  font-family: GothamRounded-Book;\n  font-size: 0.9em;\n  white-space: nowrap;\n}\n\n.legendLine {\n  width: 40px;\n}\n\n.legendLine.bus {\n  border: 2px solid rgb(0, 122, 201);\n}\n\n.legendLine.tram {\n  border: 2px solid rgb(0, 152, 95);\n}\n\n.legendLine.subway {\n  border: 2px dashed rgb(255, 99, 25);\n}\n\n.legendLine.rail {\n  border: 2px dashed rgb(141, 81, 153);\n}\n\n.legendLine.trunk {\n  border: 2px solid rgb(255, 99, 25);\n}\n\n.legendLine.l_rail {\n  border: 2px solid #0098a1;\n}\n\n.legendIcon {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: white;\n  position: absolute;\n  left: 20px;\n}\n\n.legendIcon.bus {\n  border: 2px solid rgb(0, 122, 201);\n}\n\n.legendIcon.tram {\n  border: 2px solid rgb(0, 152, 95);\n}\n\n.legendIcon.subway {\n  border: 2px solid rgb(255, 99, 25);\n}\n\n.legendIcon.rail {\n  border: 2px solid rgb(141, 81, 153);\n}\n\n.legendIcon.trunk {\n  border: 2px solid rgb(255, 99, 25);\n}\n\n.legendIcon.l_rail {\n  border: 2px solid #0098a1;\n}\n\n.primaryLegendText {\n  font-family: GothamRounded-Medium;\n}\n\n.italics {\n  font-style: italic;\n}\n\n.overlays {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  border-radius: var(--border-radius);\n}\n\n.outline {\n  text-shadow: 0px 0px 1px rgba(255, 255, 255, 1), 0px 0px 1px rgba(255, 255, 255, 1),\n    0px 0px 1px rgba(255, 255, 255, 1);\n}\n\n.attribution {\n  composes: outline;\n  margin: 8px 0;\n  font-family: GothamRounded-Medium;\n  color: black;\n}\n\n.title {\n  composes: outline;\n  margin-top: 3px;\n  margin-bottom: 3px;\n  margin-left: 3px;\n  margin-right: 8px;\n  font-size: 18px;\n  font-family: GothamRounded-Medium;\n  color: black;\n}\n\n.subtitle {\n  composes: title;\n  margin-left: 0;\n  font-family: GothamRounded-Book;\n}\n\n.center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n\n.zoneHeading {\n  font-family: GothamRounded-Book;\n  font-size: 20px;\n  vertical-align: middle;\n  line-height: 1.1rem;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  color: rgb(0, 122, 201);\n  white-space: nowrap;\n  flex-wrap: nowrap;\n}\n\n.zoneSymbol {\n  height: 60px;\n  width: 60px;\n  vertical-align: middle;\n  display: flex;\n  align-items: center;\n  padding-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `stopMap_root_CIYeP`,
	"mapContainer": `stopMap_mapContainer_Mdbsx`,
	"map": `stopMap_map_L4u9N stopMap_mapContainer_Mdbsx`,
	"miniMap": `stopMap_miniMap_oil_l stopMap_mapContainer_Mdbsx`,
	"legend": `stopMap_legend_RV8sy stopMap_mapContainer_Mdbsx`,
	"legendRow": `stopMap_legendRow_t3Yvb`,
	"legendText": `stopMap_legendText_ELeev`,
	"legendLine": `stopMap_legendLine_Q8EkG`,
	"bus": `stopMap_bus_USe5I`,
	"tram": `stopMap_tram_KimUA`,
	"subway": `stopMap_subway_XL4LV`,
	"rail": `stopMap_rail_mXhj1`,
	"trunk": `stopMap_trunk_wW15F`,
	"l_rail": `stopMap_l_rail_gnsYu`,
	"legendIcon": `stopMap_legendIcon_nIVeI`,
	"primaryLegendText": `stopMap_primaryLegendText_dx6CE`,
	"italics": `stopMap_italics_X3nTh`,
	"overlays": `stopMap_overlays_g64MF`,
	"outline": `stopMap_outline_H0yuX`,
	"attribution": `stopMap_attribution_Im4HY stopMap_outline_H0yuX`,
	"title": `stopMap_title_nFuhW stopMap_outline_H0yuX`,
	"subtitle": `stopMap_subtitle_sJDDg stopMap_title_nFuhW stopMap_outline_H0yuX`,
	"center": `stopMap_center_jW3e2`,
	"zoneHeading": `stopMap_zoneHeading_UvJcf`,
	"zoneSymbol": `stopMap_zoneSymbol_Tyisz`
};
module.exports = ___CSS_LOADER_EXPORT___;
